export interface CheckpointItem {
  type: 'group' | 'item';
}

export interface Exception {
  id: string;
  approvedAt: string | null;
  approvedBy: string | null;
  createdAt: string;
  createdBy: string | null;
  description: string;
  exception: string;
  exceptionType: string;
  isApproved: boolean | null;
}

export enum CheckpointParameterType {
  String = 'String',
  Boolean = 'Boolean',
  Integer = 'Integer',
  Float = 'Float',
  List = 'List',
  Dictionary = 'Dictionary',
}

export interface CheckpointParameter {
  paramDescription: string;
  paramName: string;
  displayName: string;
  isOptional: boolean;
  isRuntime: boolean;
  paramValue: string;
  paramType: CheckpointParameterType;
}

export interface Checkpoint {
  id: string;
  version?: string | number;
  checkpointVersion?: string | number;
  category: string;
  enabled: boolean;
  description: string;
  accountable: string;
  owner: string;
  displayName: string;
  exceptions: Exception[] | null;
  parameters: CheckpointParameter[];
  referenceSystem: string;
  isScored: boolean;
}

export interface CheckpointsStatus {
  checkpointsUnscored: string[];
  updates: {
    checkpointId: string;
    comment: string;
    preview: boolean;
    eventTime: string;
    userId: string;
  }[];
}

export type CheckpointSystemStatus =
  | 'LIVE'
  | 'PREVIEW'
  | 'MAINTENANCE'
  | 'DISABLED';

export interface CheckpointStatusWindow {
  enabled?: boolean;
  type?: 'preview' | 'maintenance' | string;
  reason?: string;
  endDate?: string;
  startDate?: string;
  [key: string]: unknown;
}

export interface CheckpointStatusObject {
  unScored?: boolean | CheckpointStatusWindow | Record<string, unknown>;
  unscored?: boolean | CheckpointStatusWindow | Record<string, unknown>;
  disabled?: boolean | CheckpointStatusWindow | Record<string, unknown>;
  [key: string]: unknown;
}

export interface SystemCheckpointConfiguration {
  checkpointId: string;
  checkpointVersion?: string | number;
  version?: string | number;
  status?: CheckpointSystemStatus | CheckpointStatusObject;
  state?: CheckpointSystemStatus;
  mode?: CheckpointSystemStatus;
  unScored?: boolean;
  unscored?: boolean;
  preview?: boolean;
  maintenance?: boolean;
  disabled?: boolean;
  comment?: string;
  note?: string;
  eventTime?: string;
  updatedAt?: string;
  updatedBy?: string;
  [key: string]: unknown;
}

export type StandardLink = {
  name?: string;
  description?: string;
  url: string;
};

export type StandardsLookupValue =
  | StandardLink[]
  | {
      standards?: StandardLink[];
      underpinnings?: StandardLink[];
      [key: string]: unknown;
    }
  | string
  | undefined;

export type StandardsData = Record<string, StandardsLookupValue>;
